import { DeviceInfo } from 'qunar-react-native';

const { scheme } = DeviceInfo;
const generateRNUrl = (pageName: string, hybridId = 'cmn_order_rn', initProps?: any) => {
    let result = `${scheme}://react/open?pageName=${pageName}&hybridId=${hybridId}`;
    if (initProps) {
        const encodeProps = JSON.stringify(initProps);
        result += `&initProps=${encodeProps}`;
    }
    return result;
};

export default generateRNUrl;
